import { FC, useEffect, useState } from "react";
import { useAuth } from "../../providers/AuthProvider";
import { useNavigate, useParams } from "react-router-dom";
import "./EditArticleButton.scss";
import { BvIcon } from "bevi-icon";

interface EditArticleButtonProps {
  onClick?: () => void;
}

const EditArticleButton: FC<EditArticleButtonProps> = ({ onClick }) => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const { userLogged } = useAuth();
  const navigate = useNavigate();
  const { id: articleId } = useParams();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 100);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const canEditArticles = userLogged?.menu?.some(m => m.name?.toLowerCase().includes("artigo")) && userLogged?.role?.toLowerCase() === "admin";

  if (!canEditArticles) {
    return null;
  }

  const handleEditClick = () => {
    if (onClick) {
      onClick();
    } else {
      navigate("/articles/list", { state: { editArticleId: articleId } });
    }
  };

  return (
    <div className="EditArticleButton" data-testid="EditArticleButton">
      <button
        onClick={handleEditClick}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        aria-label="Editar artigo"
        className={`edit-article-btn ${isScrolled ? "scrolled" : ""}`}
      >
        <BvIcon name="editSquare" color={isHovered ? "#ffffff" : "#222343"} />
      </button>
    </div>
  );
};

export default EditArticleButton;
